<!--
PendantPlate
挂立两用立牌
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌 > 挂立两用立牌" name="挂立两用立牌">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="pendantPlate" label-width="80px">
              <el-form-item label="印刷种类">
                <el-select v-model="pendantPlate['印刷']" placeholder="印刷">
                  <el-option label="单面印刷（默认底座单面团）" value="单面印刷"></el-option>
                  <el-option label="双面印刷（默认底座单面团）" value="双面印刷"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-select v-model="pendantPlate['工艺']" placeholder="请选择制作工艺">
                  <el-option label="烫金" value="烫金" name="type"></el-option>
                  <el-option label="烫银" value="烫银" name="type"></el-option>
                  <el-option label="镭射银" value="镭射银" name="type"></el-option>
                  <el-option label="珠光闪粉" value="珠光闪粉" name="type"></el-option>
                  <el-option label="磨砂闪粉" value="磨砂闪粉" name="type"></el-option>
                  <el-option label="镶钻" value="镶钻" name="type"></el-option>
                  <el-option label="透明部分" value="透明部分" name="type"></el-option>
                </el-select>
                <div style="padding:10px"></div>
                <el-alert title="其他工艺请联系客服" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 0 0 0 0;"></el-alert>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="pendantPlate['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="pendantPlate['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="pendantPlate['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="pendantPlate['数量']" :min="200" label="数量"></el-input-number>
                <el-alert title="单款起定数为200" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PendantPlate",
  data() {
    return {
      forcollapse: ['allsame'],
      pendantPlate: {
        title: "挂立两用立牌",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.pendantPlate);
       
    },
    clear() {
      this.$root.clearAlert()
      this.pendantPlate = {
        title: "挂立两用立牌",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>